import qs from 'qs';
import ENDPOINTS from 'constants/endpoints';
import initData from 'init-data';

const MESSAGING_PATH = '/messaging';

const checkUserMessagingParticipation = sellerId => {
    return fetch(ENDPOINTS.MESSAGING_PARTICIPATION + sellerId)
        .then(sellerResponse => sellerResponse.json())
        .then(data => 'participates' in data && data.participates);
};

const setUserMessagingParticipation = async messagingSettings => {
    return fetch(ENDPOINTS.MESSAGING_SET_PARTICIPATION, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(messagingSettings)
    })
        .then(userResponse => userResponse.json())
        .then(data => data);
};

const getUserMessagingEmailSetting = async () => {
    return fetch(ENDPOINTS.MESSAGING_EMAIL_SETTINGS, { credentials: 'include' })
        .then(userResponse => userResponse.json())
        .then(data => data);
};

const setUserMessagingEmailSetting = async setting => {
    return fetch(
        ENDPOINTS.MESSAGING_EMAIL_SETTINGS + '?emailNotify=' + setting,
        {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    )
        .then(userResponse => userResponse.json())
        .then(data => data);
};

/**
 * Returns base path for a thread
 *
 * @param {number} u1
 * @param {number} u2
 * @param {number} l
 * @param {object} [options]
 * @param {boolean} [options.singleThread] - Open in single thread mode
 * @param {boolean} [options.openForm] - Open message form right away
 * @param {string} [options.source] - Message source info for tracking
 * @returns {string}
 */
const getMessagingThreadLink = (u1, u2, l, options) => {
    const optionsWithDefaults = {
        singleThread: false,
        openForm: false,
        ...options
    };
    const { singleThread, ...queryParams } = optionsWithDefaults;
    return (
        (singleThread ? '/thread/' : '/threads/') +
        'u' +
        Math.min(u1, u2) +
        '_u' +
        Math.max(u1, u2) +
        '_l' +
        l +
        qs.stringify(queryParams, { addQueryPrefix: true })
    );
};

/**
 * Returns the path to a thread on Tradera's messaging page
 *
 * @param {number} u1
 * @param {number} u2
 * @param {number} l
 * @param {object} [options]
 * @returns {string}
 */
const getMessagingPageLink = (u1, u2, l, options) => {
    return (
        MESSAGING_PATH +
        (u1 && u2 && l ? getMessagingThreadLink(u1, u2, l, options) : '')
    );
};

/**
 * Get messaging url
 *
 * @returns {string}
 */
const getMessagingRemoteUrl = () => {
    return initData.messagingIframeUrl;
};

export {
    checkUserMessagingParticipation,
    setUserMessagingParticipation,
    getUserMessagingEmailSetting,
    setUserMessagingEmailSetting,
    getMessagingPageLink,
    getMessagingThreadLink,
    getMessagingRemoteUrl
};
